import includes from 'lodash/includes';

import { actions } from '@app/action/notification';
import NotificationCategories from '@app/constant/notification-categories';
import I18n from '@app/modules/i18n';
import Config from '@app/config';

const errorMessages = [
  'InvalidSender',
  'MissingSender',
  'TooManyRecipients',
  'InvalidRecipient',
  'MissingRecipients',
  'MessageTooLarge',
  'MissingFiles',
];

function extractNotification(action) {
  if (action.details) {
    return {
      ...action.details,
      date: new Date(),
    };
  }

  return {
    date: new Date(),
    text: action.text,
  };
}

export default function(state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.NOTIFICATION_TRANSFER_SET:
      if (state.transfer && includes(errorMessages, state.transfer.text)) {
        return state;
      }

      return {
        ...state,
        transfer: extractNotification(action),
      };

    case actions.NOTIFICATION_TRANSFER_CLEAR:
      return {
        ...state,
        transfer: {},
      };

    case actions.NOTIFICATION_PANEL_SET: {
      const {
        category: intermediateCategory,
        details: value,
        params,
        duration = Config.notification.duration,
      } = action;
      let translationKey;
      let category = intermediateCategory;

      switch (intermediateCategory) {
        case NotificationCategories.error: {
          translationKey = `exception.${value}`;
          break;
        }
        case 'notification':
        default: {
          // "notification" is used everywhere as a category
          // for default notification, but that should actually be "default"
          // because this is how it is used in the CSS
          // also "notification of `default` category" makes more sense
          // than "notification of `notification` category"
          // that's why this variable is overridden here
          category = NotificationCategories.default;
          translationKey = `notification.${value}`;
          break;
        }
      }

      // it may so happen that there is (still) no translation
      // and actual text is used instead of translation key
      // below is the humble guess whether it is a translation key
      // or a final text basing on presence of space character
      const html = includes(value, ' ')
        ? value
        : I18n.t(translationKey, params);

      return { ...state, panel: { category, html, duration } };
    }

    case actions.NOTIFICATION_PANEL_RESET:
      return {
        ...state,
        panel: {},
      };

    case actions.NOTIFICATION_POPOVER_SET:
      return {
        ...state,
        popover: {
          category: action.category || 'notification',
          details: action.details,
        },
      };

    case actions.NOTIFICATION_POPOVER_RESET:
      return {
        ...state,
        popover: {},
      };

    case actions.NOTIFICATION_FEATURE_DATA_SET:
      return {
        ...state,
        features: {
          storage: state.features.storage,
          data: action.details,
        },
      };
  }

  return state;
}
